/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigValidationSummary {
    getFixupPrototypeFunction() { return ConfigValidationSummary.fixupPrototype; }

    static newInstance(model: Partial<ConfigValidationSummary>): ConfigValidationSummary {
        let obj = Object.assign(new ConfigValidationSummary(), model);
        ConfigValidationSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigValidationSummary>): ConfigValidationSummary {
        if (!model) return null;
        return ConfigValidationSummary.newInstance(<ConfigValidationSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigValidationSummary) {
        if (!obj) return;

        models.ConfigValidationSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigValidationSummary): boolean {
        Object.setPrototypeOf(obj, ConfigValidationSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Region
     */
    region: string;

    /**
     * Recorder status
     */
    recorder_status: models.ConfigValidationRecorderStatus;

    /**
     * Role name
     */
    role_name: string;

    /**
     * Availability status
     */
    availability_status: models.ConfigValidationAvailabilityStatus;

}
